import React from "react";
import { LedgerDetails } from "src/shared/services/interfacev2";

interface Props {
  customer: LedgerDetails;
}

const CustomerCard: React.FC<Props> = ({ customer }) => {
  const fullName = [customer.customerDetails.firstName, customer.customerDetails.middleName, customer.customerDetails.lastName].filter(Boolean).join(" ") || "N/A";
  const primaryPhone = customer.customerDetails.phones?.find((p) => p.isPrimary)?.phone ?? customer.customerDetails.phones?.[0]?.phone ?? "N/A";
  const primaryEmail = customer.customerDetails.emails?.[0]?.email ?? "N/A";
  const formattedClientId = customer.customerDetails.refId
  ? String(customer.customerDetails.refId).padStart(4, "0")
  : "0000";

  const details = [
    { label: "Name", value: fullName },
    { label: "Client ID", value: formattedClientId },
    { label: "Phone", value: primaryPhone },
    { label: "Email", value: primaryEmail },
  ];

  return (
    <div className="rounded-xl bg-white border border-slate-400/90 shadow-inner p-3">
      <div className="mb-2">
        <h2 className="text-base font-semibold text-gray-900">Customer Details</h2>
        <p className="text-xs text-gray-500 mt-0.5">Account information & contact</p>
      </div>
      
      <div className="space-y-0.5">
        {details.map(({ label, value }) => (
          <div key={label} className="flex items-center justify-between">
            <span className="text-sm text-gray-600">{label}</span>
            <span className="text-sm font-medium text-gray-900 truncate max-w-[60%] text-right">
              {value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerCard;